<template>
  <div class="twshoppingcart">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">台灣精選源頭工廠購物車</a>
        <div>
          <button
            type="button"
            class="btn btn-primary addCarButton mr-3"
            @click="clearShoppingCart()"
          >
            清空購物車
          </button>
          <button
            type="button"
            class="btn btn-primary addCarButton"
            @click="goToTwStoreVender()"
          >
            回上一頁
          </button>
        </div>
      </nav>

      <div class="title">訂單詳情</div>
      <ul class="list-group">
        <div v-if="displayViews == null || displayViews == undefined">
          <li class="list-group-item">
            <p class="noProd">您目前沒有加入商品到購物車喔!</p>
          </li>
        </div>
        <div v-else>
          <li
            class="list-group-item"
            v-for="(displayView, index) in displayViews"
            v-bind:key="(displayView, index)"
          >
            <div class="media">
              <img
                v-bind:src="displayView.main_image"
                class="mr-3"
                width="120"
                height="120"
              />
              <div class="media-body" style="text-align: left">
                <div class="prod-block">
                  <h5 class="mt-0 prod-text">{{ displayView.product_name }}</h5>
                </div>
                <div v-if="displayView.select.sku_name != undefined">
                  <p>
                    選擇的款式:
                    <b>{{ displayView.select.sku_name }}</b>
                  </p>
                </div>
                <div v-if="displayView.select.quantity != undefined">
                  <p>
                    購買數量:
                    <b>{{ displayView.select.quantity }}</b>
                  </p>
                </div>

                <p>成本價:{{ displayView.select.price }}元</p>
                <p class="text-success">
                  此訂單可以賺:{{
                    displayView.price.pub_price * displayView.select.quantity -
                    displayView.select.price
                  }}元
                </p>
                <p>
                  <b>注意公開售價:{{ displayView.price.pub_price }}元</b>
                </p>
              </div>
              <div v-if="checkMobile == '0'">
                <br />
                <a
                  href="#"
                  class="btn btn-danger btn btn-sm"
                  style
                  @click="removeProd(index)"
                  >忍心刪除</a
                >
              </div>
            </div>
            <div v-if="checkMobile == '1'">
              <br />
              <a
                href="#"
                class="btn btn-danger btn btn-block"
                style
                @click="removeProd(index)"
                >忍心刪除</a
              >
            </div>
          </li>
        </div>
      </ul>
      <div class="alert alert-danger" role="alert">
        注意不能低於公開售價，如果發現低於廠商設定公開價格將會斷貨處理
      </div>
      <br />
      <p>
        總數量:
        <b class="text-success">{{ totalQuantity }}</b>
      </p>
      <p>
        差
        <b class="text-success">{{ freeFreightCount }}</b> 數量免運
      </p>
      <p>
        小計:
        <b class="text-danger">{{ totalPrice }}元</b>
      </p>
      <div v-if="displayViews.length > 0">
        <button class="btn btn-danger btn-lg btn-block" @click="buy()">
          去買單
        </button>
      </div>
      <div v-else>
        <button
          class="btn btn-danger btn-lg btn-block"
          @click="goToTwStoreVender()"
        >
          回上一頁
        </button>
      </div>
      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'twshoppingcart',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      fbEndpoint: 'https://m.me/2266831083395361',
      displayViews: null,
      isLoading: true,
      checkMobile: isMobile ? '1' : '0',
      freeFreightCount: 0,
      totalQuantity: 0,
      totalPrice: 0,
    }
  },
  methods: {
    buy: function () {
      const vm = this
      if (vm.displayViews != null && vm.displayViews.length > 0) {
        vm.$router.push('twshippingprofile')
      } else {
        alert('請加入商品到購物車')
      }
    },
    removeProd: function (index) {
      const vm = this
      vm.displayViews.splice(index, 1)
      localStorage.setItem('twProducts', JSON.stringify(vm.displayViews))
      vm.$forceUpdate()
      vm.totalPrice = vm.totalPriceByProduct(vm.displayViews)
      vm.totalQuantity = vm.totalQuantityByProduct(vm.displayViews)
    },
    clearShoppingCart: function () {
      const vm = this
      vm.displayViews = []
      localStorage.setItem('twProducts', JSON.stringify([]))
      vm.$forceUpdate()
      vm.totalPrice = vm.totalPriceByProduct(vm.displayViews)
      vm.totalQuantity = vm.totalQuantityByProduct(vm.displayViews)
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined ||
        localStorage.userImage == undefined ||
        localStorage.userName == undefined
      ) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        return true
      } else {
        return false
      }
    },
    goToTwStoreVender: function () {
      const vm = this
      vm.$router.push('twstorevender')
    },
    checkProductsExist: function (product) {
      const vm = this
      if (product == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋請聯絡客服',
          text: '請聯絡客服⚡ 系統異常!',
          buttons: [
            {
              title: '👉聯絡客服',
              handler: () => {
                window.location = vm.fbEndpoint
              },
            },
          ],
        })
      }
    },
    totalPriceByProduct: function (products) {
      let totalPrice = 0
      products.forEach(product => {
        totalPrice += product.select.price * product.select.quantity
      })
      return totalPrice
    },
    totalQuantityByProduct: function (products) {
      const vm = this
      let totalQuantity = 0
      let freeFreightQuantity = 0
      products.forEach(product => {
        totalQuantity += parseInt(product.select.quantity)
        freeFreightQuantity = product.free_freight_quantity
      })

      if (freeFreightQuantity - totalQuantity >= 0) {
        vm.freeFreightCount = parseInt(freeFreightQuantity - totalQuantity)
      }

      return totalQuantity
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()

    if (JSON.parse(localStorage.getItem('twProducts')) != undefined) {
      vm.displayViews = JSON.parse(localStorage.getItem('twProducts'))
      vm.isLoading = false
    }

    vm.checkProductsExist(vm.displayViews)
    vm.totalPrice = vm.totalPriceByProduct(vm.displayViews)
    vm.totalQuantity = vm.totalQuantityByProduct(vm.displayViews)
  },
}
</script>
